var exports = {
  "kL": "GroupDMAvatar.module__container___X255Vm",
  "kg": "GroupDMAvatar.module__statusDot___X255Vm",
  "O0": "GroupDMAvatar.module__iconImageContainer___X255Vm",
  "c4": "GroupDMAvatar.module__defaultIconContainer___X255Vm",
  "DE": "GroupDMAvatar.module__defaultIcon___X255Vm",
  "EQ": "GroupDMAvatar.module__multiAvatarContainer___X255Vm",
};

module.exports = exports;
